// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18lO7","importantInfo":"styles_importantInfo__29yPA"};